import { IPaginationDTO, IRoleDTO, IUserDTO } from '@/dtos';
import { generatePagination, get, post, remove } from '@/services/apiWrapper';

export const getAllUsersAPI = async (
  pagination: IPaginationDTO,
): Promise<{ data: IUserDTO[]; count: number }> => {
  const pageOptions = await generatePagination(pagination);
  const users = await get<{ data: IUserDTO[]; count: number }>(`/admin/users${pageOptions}`);
  return users;
};

export const getAllUsersByRoleAPI = async (
  role: IRoleDTO,
  exclude: string[],
  pagination: IPaginationDTO,
): Promise<{ data: IUserDTO[]; count: number }> => {
  const pageOptions = await generatePagination(pagination);
  const users = await post<{ data: IUserDTO[]; count: number }>(
    `/admin/users/role/${role.id}${pageOptions}`,
    exclude,
  );
  return users;
};

export const getAllRolesAPI = async (): Promise<{ data: IRoleDTO[]; count: number }> => {
  const users = await get<{ data: IRoleDTO[]; count: number }>(`/admin/roles`);
  return users;
};

export const getUserByIdAPI = async (id: string): Promise<IUserDTO> => {
  const users = await get<IUserDTO>(`/admin/users/${id}`);
  return users;
};

export const adminCheckEmailAPI = async (email: string, userId: string): Promise<boolean> => {
  const body = { email: email, userId: userId };
  const users = await post<boolean>(`/admin/users/checkemail`, body);
  return users;
};

export const saveUserAPI = async (user: IUserDTO): Promise<IUserDTO> => {
  const ret = await post<IUserDTO>(`/admin/users/${user.id}/save`, user);
  return ret;
};

export const createUserAPI = async (body: IUserDTO): Promise<IUserDTO> => {
  const user = await post<IUserDTO>(`/admin/users/createUser`, body);
  return user;
};

export const deleteUserAPI = async (id: string): Promise<boolean> => {
  const user = await remove<boolean>(`/admin/users/${id}`);
  return user;
};

export const resetUserPasswordAPI = async (id: string, password: string): Promise<boolean> => {
  const body = { password: password };
  const user = await post<boolean>(`/admin/users/${id}/password`, body);
  return user;
};
